import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { appSelectors } from '../../app/reducer/app-reducer';
import PropTypes from 'prop-types';
import alertIcon from '../../../assets/images/icon-alert-solid.svg';

export class InputAndAlertContainer extends PureComponent {
  isRtl = false;

  alertSize = 14;
  alertMargin = 4;

  InputAndAlertContainerDiv = styled.div(() => {
    let style = {
      display: 'block',
      position: 'relative',
      width: '100%',
      height: this.props.outsideHeight,
      marginBottom: this.props.marginBottom || 10
    };
    return style;
  });

  InputContainer = styled.div(() => {
    let style = {
      display: 'block',
      position: 'absolute',
      bottom: 0,
      top: 0
    };
    if (this.isRtl) {
      style.right = this.props.inputSideMargin;
      style.left = this.props.inputSideMargin;
    } else {
      style.left = this.props.inputSideMargin;
      style.right = this.props.inputSideMargin;
    }
    return style;
  });

  ErrorAlert = styled.div(() => {
    let style = {
      display: 'block',
      position: 'absolute',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundImage: 'url(' + alertIcon + ')',
      width: this.alertSize,
      height: this.alertSize,
      top: Math.floor((this.props.outsideHeight - this.alertSize) / 2)
    };
    if (this.isRtl) {
      style.left = this.props.inputSideMargin - (this.alertSize + this.alertMargin);
    } else {
      style.right = this.props.inputSideMargin - (this.alertSize + this.alertMargin);
    }
    return style;
  });

  // ****** render
  render = () => {
    this.isRtl = this.props.isInterfaceRtl;

    let errorAlertIcon = null;
    if (this.props.displayError) {
      errorAlertIcon = <this.ErrorAlert />;
    }

    return (
      <this.InputAndAlertContainerDiv data-qa={this.props.dataQa || 'InputAndAlertContainer'}>
        <this.InputContainer>{this.props.children}</this.InputContainer>
        {errorAlertIcon}
      </this.InputAndAlertContainerDiv>
    );
  };
}

InputAndAlertContainer.propTypes = {
  dataQa: PropTypes.string,
  displayError: PropTypes.bool,
  inputSideMargin: PropTypes.number.isRequired,
  outsideHeight: PropTypes.number.isRequired
};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state)
});

const wrapActions = {};
export const InputAndAlertContainerContainer = connect(
  mapStateToProps,
  wrapActions
)(InputAndAlertContainer);


// WEBPACK FOOTER //
// ./src/modules/app/util/InputAndAlertContainer.jsx